function getPrecision(dollarAmount) {
  const hasCents = dollarAmount % 1 !== 0;
  return hasCents ? 2 : 0;
}

function compactCurrencyFilter(price) {
  if (price === 0) {
    return 'FREE';
  }
  return `$${price.toFixed(getPrecision(price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}


export default compactCurrencyFilter;



/** WEBPACK FOOTER **
 ** ./src/components/product/PricingUtils.js
 **/